import { Component, Input, Output, EventEmitter } from '@angular/core';
import { COMPONENT_NAME, EVENT_TYPE } from '@app/constants/message.constants';
import { RatingRequest } from '@app/models';
import { MessageAction } from '@app/models/message-action.model'
import { MessageComponent } from '@app/models/message-base.component';
import { RatingCommunicationService } from '@app/services/rating-communication.service';
import { RateLimitError } from 'openai/error';

@Component({
  selector: 'app-rate-experiance',
  templateUrl: './rate-experiance.component.html',
  styleUrls: ['./rate-experiance.component.scss'],
})
export class RateExperianceComponent extends MessageComponent {
  @Input() value: number = 0;
  @Input() disabled: boolean = false;
  @Output() onValueChange = new EventEmitter<RatingRequest>();
  override type = COMPONENT_NAME.STAR_RATING
  comment: any = '';

  constructor(private ratingService: RatingCommunicationService) {
    super();
  }

  stars = Array(5).fill(0);

  onStarClick(newValue: number): void {
    if (newValue !== this.value) {
      this.value = newValue;
      this.emitValueChange();
    }
  }

  OnInputChange() {
    this.emitValueChange();
  }

  private emitValueChange(): void {
    this.onValueChange.emit({ rating: this.value, comment: this.comment });
    this.ratingService.onValueChange.emit({ rating: this.value, comment: this.comment });
  }
}